// Read-only audit-log helper (superadmin UI). The auditLog collection is written
// only by the backend Admin SDK (services/llm-proxy/audit.js); Firestore rules
// allow superadmins to read and forbid all client writes.
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { firestoreDb as db } from '../config/firebase';

/**
 * List the most recent audit entries, newest first.
 * @param {number} max
 * @returns {Promise<Array<{id,actorUid,actorEmail,action,targetOrgId,targetEmail,details,ts}>>}
 */
export async function listAuditLog(max = 50) {
  if (!db) return [];
  const snap = await getDocs(query(collection(db, 'auditLog'), orderBy('ts', 'desc'), limit(max)));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}
